import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// eslint-disable-next-line @typescript-eslint/unbound-method -- recommended by Chakra-UI
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(radioAnatomy.keys);

// default base style from the Radio theme
const baseStyle = definePartsStyle({
  label: {},
  control: {},
  container: {},
});

const primary = definePartsStyle({
  label: {},
  control: {
    bgColor: 'darkerOffGray',
    borderWidth: '1px',
    borderColor: 'primaryBlack',
    _hover: {
      borderColor: 'primaryBlack',
    },
    _checked: {
      bgColor: 'primaryBlack',
      borderColor: 'primaryBlack',
      _hover: {
        bgColor: 'primaryBlack',
        borderColor: 'primaryBlack',
      },
      _before: {
        bgColor: 'white',
      },
    },
  },
  container: {},
});

const sizes = {
  xl: definePartsStyle({
    control: {
      w: '22px',
      h: '22px',
    },
  }),
  lg: definePartsStyle({
    control: {
      w: '20px',
      h: '20px',
    },
  }),
  md: definePartsStyle({
    control: {
      w: '18px',
      h: '18px',
    },
  }),
};

const RadioTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    primary,
  },
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
  sizes,
});

export default RadioTheme;
